import { motion } from "framer-motion";
import heroImg from "@/assets/custom-staircase-matching-walnut-flooring-farmington-hills-mi.webp";
import QuoteModal from "@/components/QuoteModal";
import { REVIEW_STATS, REVIEW_RATING_TEXT } from "@/data/reviewStats";

const Hero = () => {
  return (
    <section className="relative h-auto min-h-[100svh] lg:h-[100svh] lg:min-h-[560px] lg:max-h-[900px] flex items-end overflow-hidden">
      <div className="absolute inset-0">
        <img width={1920} height={1080} loading="eager" decoding="async" fetchPriority="high"
          src={heroImg}
          alt="Red oak staircase stained to match a hand scraped Dusky Walnut floor, Farmington Hills, MI"
          title="1 Wood Floors: The Authority in Species Integration"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-foreground/20 to-transparent" />

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 pt-32 md:pt-40 pb-10 md:pb-16 px-5 md:px-10 lg:px-16 max-w-5xl"
      >
        <p className="bg-neutral-950 text-gold-100 rounded-sm px-2 py-1 w-fit text-[10px] md:text-[11px] font-semibold tracking-normal uppercase mb-3 md:mb-4">
          NWFA CERTIFIED INSPECTOR, SPECIFYING CONSULTANT, METRO DETROIT
        </p>
        <h1 className="font-display text-4xl md:text-5xl lg:text-[4.25rem] xl:text-7xl font-semibold leading-[1.1] tracking-tight text-primary-foreground max-w-[820px]">
          Custom Crafted Hardwood Floors in Livonia and Southeast Michigan
        </h1>
        <p className="mt-3 md:mt-4 bg-neutral-950 text-gold-100 rounded-sm px-2 py-1 w-fit text-[13px] md:text-[15px] font-light max-w-[750px] leading-[1.85]">
          NWFA Certified Installer, Wood Flooring Inspector, Sand & Finisher, and Sales Advisor
        </p>
        <p className="font-display text-xl md:text-2xl lg:text-3xl font-light text-primary-foreground/70 mt-2 leading-[1.2] max-w-[820px]">
          Installation, Refinishing & Custom <em className="italic font-light text-gold-300">Design</em>
        </p>
        <p className="mt-4 md:mt-6 text-[13px] md:text-[15px] font-light text-primary-foreground/55 max-w-[750px] leading-[1.85]">
          From dust contained refinishing to custom manufactured wide plank, we bring NWFA certified expertise to every surface. Whether your home sits on a lakefront, a crawl space, or features radiant heat, we provide the forensic insight and technical specification required to engineer a flooring system built for a lifetime of performance in the Michigan climate.
        </p>
        <div className="flex items-center gap-3 mt-4 md:mt-5 bg-primary-foreground/[.06] border border-primary-foreground/10 rounded-full px-3 md:px-4 py-2 w-fit backdrop-blur-sm">
          <span className="text-[#ffd60a] text-sm tracking-wider">★★★★★</span>
          <span className="text-[11px] md:text-xs text-primary-foreground/70">
            <strong className="text-primary-foreground">{REVIEW_RATING_TEXT} ★ · {REVIEW_STATS.count} Google Reviews</strong>
          </span>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 mt-6 md:mt-8">
          <QuoteModal
            trigger={
              <button className="bg-primary text-primary-foreground px-6 py-3 rounded-full text-sm font-medium hover:bg-gold-400 transition-colors text-center shadow-[0_4px_20px_rgba(180,130,40,0.35)]">
                Schedule Showroom Visit
              </button>
            }
          />
          <a href="tel:2483258853" className="border border-primary-foreground/25 text-primary-foreground px-6 py-3 rounded-full text-sm font-medium hover:bg-primary-foreground/10 transition-colors text-center">
            📞 Call (248) 325-8853
          </a>
        </div>
      </motion.div>

      <div className="absolute bottom-8 right-8 hidden lg:flex flex-col items-center gap-2 z-10">
        <div className="w-px h-8 bg-primary-foreground/20 animate-pulse" />
        <span className="text-[9px] font-semibold tracking-[.16em] uppercase text-primary-foreground/30">Scroll</span>
      </div>
    </section>
  );
};

export default Hero;
